import React from 'react';
import { useHistory } from 'react-router-dom';
import { AuthHeader } from 'components';
import { AuthIntegrationMarketing } from 'components/Auth/AuthMarketing';
import Login from 'components/Auth/Login';
import useConnectIntegration from 'hooks/useConnectIntegration';
import { useGoogleLogin } from 'hooks/useGoogleLogin';
import Utils from 'lib/Utils';
import { routeConstants } from 'routes';
import { IAuthMFARequired } from 'types';
import { AuthMFAVerification } from '../Auth';
import AuthTerms from '../Auth/AuthTerms';

export const ConnectIntegrationLogin: React.FC = () => {
  const history = useHistory();
  const integration = useConnectIntegration();

  const { googleAuthInit, googleUnavailable } = useGoogleLogin({
    redirectUri: Utils.buildUrl(routeConstants.public.redirectGoogle.integrationLogin, [integration.name]),
  });

  const renderAuthHeader = () => <AuthHeader logo={integration?.logo()} data-cy="auth-header-login" title={integration?.title} subtitle={integration?.subtitle} />;

  const onMFASuccess = () => history.push(`/connect/${integration.name}/connections`);

  const renderMFAVerificationAuthHeader = (mfaRequired: IAuthMFARequired, onBack: () => void) => (
    <AuthHeader logo={integration?.logo()} data-cy="auth-mfa-verify-header" title={integration?.title} subtitle="Enter the code sent to your mobile phone" onBack={onBack} value={`xxx-xxx-${mfaRequired.phoneLast4}`} />
  );

  return (
    <Login
      handleGoogleLogin={googleAuthInit}
      isGoogleUnavailable={googleUnavailable}
      authHeader={renderAuthHeader()}
      authTerms={<AuthTerms />}
      onForgotPasswordClick={() => history.push(`${routeConstants.public.resetPassword}?integrationName=${integration.name}`)}
      authMarketing={<AuthIntegrationMarketing integration={integration.name} />}
      renderMFAVerification={({ mfaRequired, onBack }) => <AuthMFAVerification mfaRequired={mfaRequired} onSuccess={onMFASuccess} authHeader={renderMFAVerificationAuthHeader(mfaRequired, onBack)} />}
    />
  );
};
